import type { MasterColour } from '../gql';

import { randColor, randNumber } from '@ngneat/falso';

const mockMasterColour = (overwrite?: Partial<MasterColour>): MasterColour => ({
    // This __typename is needed for mocking with @apollo/client/testing
    // see: https://github.com/apollographql/apollo-client/issues/8276#issuecomment-847064393

    colourGroupNumbers: [],
    masterColourName: `${randColor()} (DUMMY)`,
    masterColourNumber: randNumber({ min: 1, max: 9999999999 }),
    masterColourHexCode: randColor(),
    isDeleted: false,
    ...overwrite,
    ['__typename']: 'MasterColour',
});

const mockMasterColours = (amount = 10): Array<MasterColour> =>
    Array.from({ length: amount }, () => mockMasterColour()).sort((a, b) =>
        a.masterColourName.localeCompare(b.masterColourName)
    );

export { mockMasterColour, mockMasterColours };
